import { render, staticRenderFns } from "./authenticationdocs.vue?vue&type=template&id=3ef83477&"
import script from "./authenticationdocs.vue?vue&type=script&lang=js&"
export * from "./authenticationdocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ef83477')) {
      api.createRecord('3ef83477', component.options)
    } else {
      api.reload('3ef83477', component.options)
    }
    module.hot.accept("./authenticationdocs.vue?vue&type=template&id=3ef83477&", function () {
      api.rerender('3ef83477', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ugsrc/components/Login/authenticationdocs.vue"
export default component.exports